import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { MinimizeToast, SubmitNotificationForm } from '../../../store/partials/Notification';
import { RemoveNotifications, ClickButton, ClickNotification } from '../../../store/Actions';
import type { StoredNotification } from '../../../model/StoredNotification';
import type { TemplateMarkdown } from '../../../../client/templates/templates';
import {
  NotificationCardComponent,
  NotificationCardComponentProps,
} from './NotificationCardComponent';
import { RootState } from 'src/provider/store/State';

const mapDispatch = (dispatch: Dispatch, ownProps: NotificationCardComponentProps) => ({
  remove:
    ownProps.remove ??
    (async (notification: StoredNotification) =>
      (dispatch(new RemoveNotifications([notification])) as unknown) as Promise<void>),
  minimize:
    ownProps.minimize ??
    ((notification: StoredNotification) =>
      (dispatch(new MinimizeToast(notification)) as unknown) as Promise<void>),
  clickAction:
    ownProps.clickAction ??
    ((notification: StoredNotification) =>
      (dispatch(new ClickNotification(notification)) as unknown) as Promise<void>),
  clickButtonAction:
    ownProps.clickButtonAction ??
    (async (notification: StoredNotification, buttonIndex: number) =>
      (dispatch(new ClickButton(notification, buttonIndex)) as unknown) as Promise<void>),
  submitForm:
    ownProps.submitForm ??
    (async (notification: StoredNotification, form: Record<string, unknown>) =>
      (dispatch(
        new SubmitNotificationForm(notification as StoredNotification<TemplateMarkdown>, form)
      ) as unknown) as Promise<void>),
});

const mapStateToProps = (state: RootState, props: NotificationCardComponentProps) => {
  const notification = state.notifications.find(
    (not) => not.id === (props.notification as StoredNotification).id
  );

  return {
    ...props,
    revisionNumber: notification?.modifiers?.revision,
  };
};

export const NotificationCard = connect(mapStateToProps, mapDispatch)(NotificationCardComponent);

NotificationCard.displayName = 'ConnectedNotificationCard';
